import { AlertTriangle, Check, Loader2 } from "lucide-react";

/** Floating autosave indicator for the diary (saving / saved / error with retry). */
export function SaveStatus({ save }) {
  if (save.status === "idle") return null;
  const pill = "fixed bottom-4 left-1/2 z-30 flex max-w-[92vw] -translate-x-1/2 items-center gap-2 rounded-full px-4 py-2 text-sm font-semibold shadow-lg";
  if (save.status === "error") {
    return (
      <div className={`${pill} bg-red-700 text-white`} role="alert" data-testid="diary-save-error">
        <AlertTriangle className="h-4 w-4 shrink-0" />
        <span>{save.error}</span>
        {save.closed
          ? <button type="button" onClick={() => window.location.reload()} className="underline" data-testid="diary-save-reload">Reload</button>
          : <button type="button" onClick={save.retry} className="underline" data-testid="diary-save-retry">Try again</button>}
      </div>
    );
  }
  return (
    <div className={`${pill} bg-zinc-900 text-white`} aria-live="polite" data-testid="diary-save-status">
      {save.status === "saving" ? <Loader2 className="h-4 w-4 animate-spin" /> : <Check className="h-4 w-4" />}
      {save.status === "saving" ? "Saving…" : "Saved"}
    </div>
  );
}
